// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getStorage,
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBRwxqU4sNpsMj1N6fNBmQrv1Xwhhntc-A",
  authDomain: "rosemount-financial-solu-4f940.firebaseapp.com",
  projectId: "rosemount-financial-solu-4f940",
  storageBucket: "rosemount-financial-solu-4f940.appspot.com",
  messagingSenderId: "9919024994",
  appId: "1:9919024994:web:962e5eea5d63f29994a63b",
  measurementId: "G-4EEML16NTY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const dbAML = getFirestore(app, "check2-internal");
const dbLOA = getFirestore(app, "letter-of-authority");
const dbFinancialPromotions = getFirestore(app, "financial-promotions");
const storage = getStorage(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const analytics = getAnalytics(app);

provider.addScope("email");
provider.addScope("profile");

export {
  firestore,
  auth,
  storage,
  provider,
  app,
  dbAML,
  dbLOA,
  dbFinancialPromotions,
  ref,
  signInWithPopup,
  listAll,
  getDownloadURL,
  getAuth,
  onAuthStateChanged,
};

function UploadFolder() {
  const handleUpload = async (event) => {
    const files = event.target.files;

    for (const file of files) {
      // Use the full path within the selected folder
      const storageRef = ref(storage, file.webkitRelativePath);
      try {
        // Upload the file to Firebase Storage
        await uploadBytes(storageRef, file);
        // console.log(`Uploaded: ${file.webkitRelativePath}`);
      } catch (error) {
        // console.error(`Error uploading ${file.webkitRelativePath}:`, error);
      }
    }
  };

  return (
    <div>
      <h1>Upload Folder</h1>
      <input
        type="file"
        webkitdirectory="true"
        directory="true"
        onChange={handleUpload}
      />
    </div>
  );
}

export default UploadFolder;
